import React from "react";
import siteContent from "../../data/siteContent";
import QuantityPricing from "../common/QuantityPricing";
import "../../styles/app.css";

function ProductSection() {
  const handleCheckout = ({ quantity, total, unitPrice }) => {
    const baseUrl = "https://seguro.estampasbrasil.com.br/r";
    const token = "HUTQU7XPKY";

    const params = new URLSearchParams();

    // 🔥 METADATA (vai junto pro pedido)
    params.append("metadata[produto]", "rolo-dtf");
    params.append("metadata[metragem]", quantity);
    params.append("metadata[valor_total]", total.toFixed(2));
    params.append("metadata[valor_unitario]", unitPrice.toFixed(2));

    // 📊 UTM (pra tráfego pago)
    params.append("utm_source", "site");
    params.append("utm_medium", "botao");
    params.append("utm_campaign", "dtf_checkout");

    const checkoutUrl = `${baseUrl}/${token}:${quantity}?${params.toString()}`;

    window.location.href = checkoutUrl;
  };

  return (
    <section id="produtos">
      <div className="produto-wrap reveal">
        <span className="prod-badge">{siteContent.product.label}</span>

        <div className="produto-card">
          <div className="pricing-table-card">
            <div className="pricing-header">
              <span className="pricing-mini">Tabela de preços</span>
              <h3>Escolha sua metragem</h3>
              <p>Quanto mais metros, menor o valor por metro.</p>
            </div>

            <div className="pricing-grid">
              <div className="price-box">
                <div className="price-box-top basic">
                  <span>1 a 9 metros</span>
                </div>
                <div className="price-box-body">
                  <strong>R$ 49,90</strong>
                  <ul>
                    <li>8 passadas de colorido</li>
                    <li>8 passadas de branco</li>
                    <li>Metragem 58x100</li>
                    <li>Envio rápido em até 48h</li>
                  </ul>
                </div>
              </div>

              <div className="price-box featured">
                <div className="price-box-top premium">
                  <span>10 a 30 metros</span>
                </div>
                <div className="price-box-body">
                  <strong>R$ 46,90</strong>
                  <ul>
                    <li>8 passadas de colorido</li>
                    <li>8 passadas de branco</li>
                    <li>Metragem 58x100</li>
                    <li>Frete grátis</li>
                  </ul>
                </div>
              </div>

              <div className="price-box">
                <div className="price-box-top business">
                  <span>31+ metros</span>
                </div>
                <div className="price-box-body">
                  <strong>R$ 39,90</strong>
                  <ul>
                    <li>8 passadas de colorido</li>
                    <li>8 passadas de branco</li>
                    <li>Metragem 58x100</li>
                    <li>Frete grátis</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <h2 className="prod-name">
            {siteContent.product.title}{" "}
            <span>{siteContent.product.titleAccent}</span>
          </h2>

          <p className="prod-desc">
            {siteContent.product.description}
          </p>

          <div className="prod-feats">
            {siteContent.product.features.map((feature) => (
              <div className="feat" key={feature}>
                <span className="feat-dot" />
                <span>{feature}</span>
              </div>
            ))}
          </div>

          <QuantityPricing onCheckout={handleCheckout} />
        </div>
      </div>
    </section>
  );
}

export default ProductSection;